<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Interface</th>
        <th class="text-sm">Connection Status</th>
        <th class="text-sm">Admin Status</th>
        <th class="text-sm">Duplex</th>
        <th class="text-sm">Speed</th>
        <th class="text-sm">Flow Control</th>
        <th class="text-sm">MAC Address</th>
        <th class="text-sm">Port Description</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="8">
            <Skalaton />
          </td>
        </tr>
      </template>
      <template v-else-if="hasPortData">
        <tr
          v-for="(port, index) in portDataArray"
          :key="index"
        >
          <td class="text-sm font-weight-bold">{{ port['Interface'] || port.interface || 'N/A' }}</td>
          <td class="text-sm">
            <span
              class="badge"
              :class="getConnectionClass(port['Connection state'] || port.connection)"
              style="text-transform: uppercase; color: rgb(255 249 249) !important;"
            >
              {{ formatConnectionStatus(port['Connection state'] || port.connection) }}
            </span>
          </td>
          <td class="text-sm">
            <span
              class="badge"
              :class="getAdminClass(port['Enable'] || port.enable)"
              style="text-transform: uppercase; color: rgb(255 249 249) !important;"
            >
              {{ port['Enable'] || port.enable || 'N/A' }}
            </span>
          </td>
          <td class="text-sm">{{ formatDuplex(port['Duplex'] || port.duplex) }}</td>
          <td class="text-sm">{{ formatSpeed(port['Speed'] || port.speed) }}</td>
          <td class="text-sm">
            <span
              class="badge"
              :class="getFlowClass(port['Flow control'] || port.flow)"
              style="text-transform: uppercase; color: rgb(255 249 249) !important;"
            >
              {{ port['Flow control'] || port.flow || 'N/A' }}
            </span>
          </td>
          <td class="text-sm font-monospace">{{ formatMacAddress(port['MAC Address'] || port.mac) }}</td>
          <td class="text-sm">{{ port['Port Description'] || port.description || 'N/A' }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="8" class="text-center">
            <Skalaton />
            <!-- No port status data available -->
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'BdcomEponPortStatusTable',
  components: {
    Skalaton
  },
  props: {
    portInfo: {
      type: [Array, Object],
      default: () => []
    },
    loading: Boolean
  },
  computed: {
    hasPortData() {
      if (Array.isArray(this.portInfo)) {
        return this.portInfo.length > 0;
      }
      if (this.portInfo && typeof this.portInfo === 'object') {
        if (this.portInfo.ports && Array.isArray(this.portInfo.ports)) {
          return this.portInfo.ports.length > 0;
        }
        if (this.portInfo.data && Array.isArray(this.portInfo.data)) {
          return this.portInfo.data.length > 0;
        }
        return Object.keys(this.portInfo).length > 0;
      }
      return false;
    },
    portDataArray() {
      if (Array.isArray(this.portInfo)) {
        return this.portInfo;
      }
      if (this.portInfo && typeof this.portInfo === 'object') {
        if (this.portInfo.ports && Array.isArray(this.portInfo.ports)) {
          return this.portInfo.ports;
        }
        if (this.portInfo.data && Array.isArray(this.portInfo.data)) {
          return this.portInfo.data;
        }
        return [this.portInfo];
      }
      return [];
    }
  },
  methods: {
    formatConnectionStatus(status) {
      if (!status || status === '---') return 'N/A';
      if (status.toLowerCase() === 'connect') return 'Connected';
      if (status.toLowerCase() === 'down') return 'Down';
      return status;
    },
    
    formatDuplex(duplex) {
      if (!duplex || duplex === '---') return 'N/A';
      return duplex;
    },
    
    formatSpeed(speed) {
      if (!speed || speed === '---') return 'N/A';
      return speed;
    },
    
    formatMacAddress(mac) {
      if (!mac) return 'N/A';
      // Convert formats like AC12.8EF0.6856 to AC:12:8E:F0:68:56
      return mac.replace(/\./g, ':').toUpperCase();
    },
    
    getConnectionClass(status) {
      if (!status || status === '---') return 'bg-secondary';
      const statusLower = status.toLowerCase();
      if (statusLower === 'connect' || statusLower === 'connected') return 'bg-success';
      if (statusLower === 'down') return 'bg-secondary';
      return 'bg-warning';
    },
    
    getAdminClass(status) {
      if (!status) return 'bg-secondary';
      const statusLower = status.toLowerCase();
      if (statusLower === 'enable' || statusLower === 'enabled') return 'bg-success';
      if (statusLower === 'disable' || statusLower === 'disabled') return 'bg-danger';
      return 'bg-warning';
    },
    
    getFlowClass(status) {
      if (!status) return 'bg-secondary';
      const statusLower = status.toLowerCase();
      if (statusLower === 'off') return 'bg-secondary';
      if (statusLower === 'on') return 'bg-success';
      return 'bg-warning';
    }
  }
}
</script>

